/* src/app/intern/intern-search/intern-search.component.scss */
.searchHeader {
  display: flex;
  justify-content: space-between;
  background-color: #003a71;
  color: #FFF;
}
.searchHeader .searchHeader__closeIcon {
  cursor: pointer;
  position: relative;
  top: 15px;
  right: 15px;
}
tr.intern-row:hover {
  background: #777;
  cursor: pointer;
}
tr.intern-row:hover td {
  color: white;
}
.highlight {
  font-weight: bolder;
  background-color: yellow;
  color: #777;
}
div#search-form {
  padding-top: 15px;
  width: 100%;
  text-align: center;
}
div#search-form form {
  margin: 0 auto;
  display: block;
}
.mat-column-company {
  padding: 0px 0px 0px 24px;
}
.mat-column-internNumber {
  padding: 0px 0px 0px 5px;
}
.mat-column-lastName,
.mat-column-firstName,
.mat-column-emailAddress,
.mat-column-college,
.mat-column-campus,
.mat-column-district,
.mat-column-status,
.mat-column-city,
.mat-column-state,
.mat-column-dob {
  padding: 1px;
}
.mat-column-ssn {
  padding: 0px 20px 0px 0px;
}
/*# sourceMappingURL=intern-search.component.css.map */
